import { createGlobalStyle } from './index'
import fontFiles from "./fonts";

export const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: "Slowly-Two";
    font-style: normal;
    font-weight: normal;
    src: local("Slowly Two"), local("Slowly-Two"), url(${fontFiles.SlowlyTwoTTF}) format("truetype"), url(${fontFiles.SlowlyTwoWOFF}) format("woff");;
  }

  @import url('https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i,800,800i');
  @import url('https://fonts.googleapis.com/css?family=Amatic+SC|Thasadith:400,400i,700');
  @import url('https://fonts.googleapis.com/css?family=Karma');

  * {
    box-sizing: border-box;
  }

  html,
  body {
    background: #FFF;
    font-family: 'Karma', sans-serif !important;
    min-height: 100%;
    min-width: 320px;
    padding: 0;
    margin: 0;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Amatic SC', sans-serif !important;
  }

  h6 {
    margin-bottom: 8px !important;
    font-size: 22px !important;
    font-style: normal !important;
  }

  #___gatsby {
    #mc_embed_signup {
      #mc-embedded-subscribe-form {
        padding: 0;
        text-align: center;
      }

      #mce-EMAIL {
        background: rgba(255, 255, 255, 0.4);
        padding: 3px 12px;
        margin: 0 auto 10px auto;
        height: 36px;
        min-height: 36px;

        &:focus {
          background: rgba(255, 255, 255, 0.6);
          outline: none;
        }
      }

      #mc_embed_signup_scroll label {
        font-family: 'Amatic SC',sans-serif !important;
        font-size: 24px;
      }

      #mc-embedded-subscribe {
        background: #000;
        text-transform: uppercase;
        color: #fff;
        padding: 4px 20px 2px 20px;
        text-align: center;
        display: inline-block;
        height: auto;
        font-weight: bold;
        margin: 0;
        font-size: 12px;
        width: auto;
      }
    }
  }
`